import {Avatar, makeStyles} from "@material-ui/core";
import React, {useState} from "react";
import AppColors from "../colors/AppColors";
import {red} from "@material-ui/core/colors";
import CloseIcon from "@material-ui/icons/Close";

const TicketView = React.forwardRef(function (props: any, ref: any) {

    const winningNumbers = props.winningNumbers;
    const numbersCount = props.numbersCount;
    const ticket = props.ticket;
    const activeTicketController = props.activeTicketController;
    const removeFromTickets = props.removeFromTickets;
    const selected = props.selected ?? false;

    const useTicketViewStyle = makeStyles((_theme) => ({
        root: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            marginBottom: 10,
            padding: 10,
            borderRadius: 50,
            cursor: 'pointer',
            backgroundColor: selected ? AppColors.CARD_BACKGROUND_COLOR_LIGHT : 'transparent',
            '&:hover': {
                backgroundColor: AppColors.CARD_BACKGROUND_COLOR_LIGHT,
            },
        },
        digits: {
            width: 35,
            height: 35,
            marginRight: 15,
            marginBottom: 15,
            fontWeight: 600,
            color: AppColors.BLACK,
            cursor: 'pointer',
            backgroundColor: AppColors.WHITE,
            '&:hover': {
                backgroundColor: AppColors.ACCENT_COLOR,
            }
        },
        redDigits: {
            backgroundColor: red[400],
            color: AppColors.WHITE,
            fontWeight: 600,
            width: 35,
            height: 35,
            marginRight: 7,
        },
        luckyDigits: {
            backgroundColor: AppColors.GREEN,
            color: AppColors.WHITE,
            fontWeight: 600,
            width: 35,
            height: 35,
            marginRight: 7,
        },
        closeIcon: {
            color: 'white',
            display: 'none',
        }
    }));

    const classes = useTicketViewStyle();
    const [style, setStyle] = useState({display: 'none'});

    const handleClick = () => {
        setStyle({display: 'block'});
        activeTicketController(ticket);
    }

    const removeTicket = () => {
        removeFromTickets(ticket);
    }

    return <div
        key={props.key}
        ref={ref}
        onClick={handleClick}
        className={classes.root}
        onMouseEnter={() => {
            setStyle({display: 'block'});
        }}
        onMouseLeave={() => {
            setStyle({display: 'none'})
        }}>
        {
            Array.from(Array(numbersCount).keys()).map((number) => (
                <Avatar
                    className={winningNumbers.includes(ticket.numbers[number])
                        ? classes.luckyDigits
                        : classes.redDigits}>
                    {ticket.numbers[number] ?? ""}
                </Avatar>
            ))
        }
        <CloseIcon onClick={removeTicket} className={classes.closeIcon} style={style}/>
    </div>
});
export default TicketView;